import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'store';

var ModalTerms = function ModalTerms(_ref) {
  var closeModal = _ref.closeModal;
  var terms = useSelector(function (state) {
    return state.site.terms;
  });
  return /*#__PURE__*/_jsx("div", {
    className: "dimd-layer",
    children: /*#__PURE__*/_jsx("div", {
      className: "inner big-type",
      children: /*#__PURE__*/_jsxs("section", {
        className: "privacy-w",
        children: [/*#__PURE__*/_jsx("div", {
          dangerouslySetInnerHTML: {
            __html: terms.text
          }
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "btn-close",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx("span", {
            children: "\uD31D\uC5C5 \uB2EB\uAE30"
          })
        })]
      })
    })
  });
};

export default ModalTerms;